module.exports = __webpack_public_path__ + "static/media/feat-underground-hero.212512f6.jpg";